// @flow
import React from 'react';
import Link from '@waglabs/link';
import Flex from '@waglabs/flex';
import Box from '@waglabs/box';
import Icon from '@waglabs/icon';

import { BodyContainer } from '../BodyContainer';
import { NavigationItem } from './components/NavigationItem';
import routes from './routes';

import {
  HOMEPAGE,
} from '../../constants/routes.constants';

type Props = {
  onClick: () => void,
  currentPathname: string,
};

export const Navigation = ({
  onClick,
  currentPathname,
}: Props) => (
  <Flex
    width={1}
    boxSizing="border-box"
    height={[50, 60, 70, 80]}
    px={[1, 4]}
    borderBottom={1}
    borderColor="wagGray"
    left={0}
    bg="white"
    justifyContent="center"
    flexShrink="0"
  >
    <BodyContainer>
      <Flex
        justifyContent={['center', 'space-between']}
        boxSizing="border-box"
        width={1}
        height="100%"
        alignItems="center"
        position="relative"
      >
        <Box
          display={['block', 'none']}
          position="absolute"
          left={10}
          top={15}
        >
          <Icon
            name="hamburger"
            onClick={onClick}
          />
        </Box>
        <Link
          href={HOMEPAGE}
        >
          <Icon
            name="wagTextLogo"
            pt={[2]}
            width={[60, 70, 80, 90]}
            hover
          />
        </Link>
        <Flex
          display={['none', 'flex']}
        >
          {routes.map((route, index) => (
            <NavigationItem
              currentPathname={currentPathname}
              key={route.id}
              index={index}
              route={route}
            />
          ))}
        </Flex>
      </Flex>
    </BodyContainer>
  </Flex>
);
